module.exports = __webpack_public_path__ + "img/78.6.CODm.cb8c33f2.png";